import {ActivityLevel, ActivitySlider} from './Custom/Activity';
import React, {Component} from 'react';
import Consent from './Custom/Consent';
import FormAthlete from './Forms/Athlete.json';
import FormBuilder from 'bodyspec-form-builder';
import FormDXA from './Forms/DXA.json';
import FormOther from './Forms/Other.json';
import FormRMR from './Forms/RMR.json';
import FormThirdParty from './Forms/ThirdParty.json';
import FormVO2 from './Forms/VO2.json';
import PropTypes from 'prop-types';
import RedText from './Custom/RedText';
import SmallText from './Custom/SmallText';

import './Intake.css';


const initURL = '/api/v0/intakes/init';
const intakeConfigs = {
  Athlete: {
    apiURL: '/api/v0/intakes/athlete/create',
    autoSet: {
      athlete_disabled: true,
    },
    customFields: {
      'consent': Consent,
    },
    form: FormAthlete,
  },

  DXA: {
    apiURL: '/api/v0/intakes/dxa/create',
    customFields: {
      'consent': Consent,
      'small-text': SmallText,
    },
    form: FormDXA,
  },

  Done: {
    form: FormOther.Done,
  },

  Index: {
    form: FormOther.Index,
  },

  RMR: {
    apiURL: '/api/v0/intakes/rmr/create',
    customFields: {
      'activity-level': ActivityLevel,
      'activity-slider': ActivitySlider,
      'consent': Consent,
      'small-text': SmallText,
    },
    form: FormRMR,
  },

  ThirdParty: {
    apiURL: '/api/v0/intakes/thirdparty/create',
    autoSet: {
      third_party_disabled: true,
    },
    customFields: {
      'red-text': RedText,
    },
    form: FormThirdParty,
  },

  VO2: {
    apiURL: '/api/v0/intakes/vo2/create',
    customFields: {
      'consent': Consent,
      'small-text': SmallText,
    },
    form: FormVO2,
  },
};

class Intake extends Component {
  state = {}

  componentWillMount = () => {
    const getter = this.getState();
    if (getter) {
      getter()
        .then((resp) => resp.json())
        .then((json) => {
          const autoSet = this.configs().autoSet;
          if (autoSet) {
            for (const key of Object.keys(autoSet)) {
              json[key] = autoSet[key];
            }
          }
          this.setState({...json});
        });
    }
  }

  getState = () => {
    const token = this.props.match.params.token;
    if (!token) return null;

    // The server will verify that we generated this token and
    // then return the user or intake data if the token is valid.
    return () => fetch(initURL, {
      body: token,
      method: 'POST',
    });
  }

  configs = () => intakeConfigs[this.props.config];

  handleSubmit = (s) => {
    // Clear any pending exceptions
    this.setState({
      exception: null,
    });

    // Post the form as JSON
    const postData = {
      body: JSON.stringify(s),
      headers: {'Content-Type': 'application/json'},
      method: 'POST',
    };

    fetch(this.configs().apiURL, postData)
      .then((resp) => {
        // Our form was accepted!
        if (resp.status === 200) {
          try {
            // Clear everything
            const clear = {};
            for (const k of Object.keys(s)) {
              clear[k] = null;
            }
            this.setState(clear);

            this.context.router.history.push('/done');
          } catch (err) {
            window.location = '/done';
          }
          return false;
        }

        // The edge server was probably not able to connect to the API
        if (resp.status === 500) {
          this.setState({
            exception: 'We ran into issues submitting the intake form ' +
              'to the server. Please try again later.',
          });
          return false;
        }

        // We have some other type of error, let's try to print it out
        return resp.json();
      })
      .then((json) => {
        // We likely got a 400 Bad Argument from the API server
        if (json && json.message) {
          this.setState({
            exception: json.message,
          });
        }
      })
      .catch((err) => {
        // This should only happen because of a network error
        this.setState({
          exception: 'Could not connect to server. Please try again later.',
        });
      });
  }

  handleUpdate = (s, u) => {
    // Unset the user_id if we're updating the name or email
    const old = this.state;
    if (old.user_id && s.user_id) {
      if (u.first_name || u.last_name || u.email) {
        this.setState({user_id: null});
        return;
      }
    }
  }

  render = () => (
    <FormBuilder
      {...this.configs()}
      className='Intake'
      store={this}
      onSubmit={this.handleSubmit}
      onUpdate={this.handleUpdate}
    />
  );
}

Intake.contextTypes = {
  router: PropTypes.object.isRequired,
};

Intake.propTypes = {
  config: PropTypes.string,
  match: PropTypes.object,
};

export default Intake;



// WEBPACK FOOTER //
// ./src/components/Intake/Intake.js